export default "__VITE_ASSET__EWzVEDru__"